(function () {
  const normalize = (value) =>
    String(value || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9+ ]/g, " ")
      .replace(/\s+/g, " ")
      .trim();

  const escapeHtml = (value) =>
    String(value || "").replace(/[&<>"']/g, (char) => ({
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#039;"
    }[char]));

  const scoreEntry = (entry, question) => {
    const normalizedQuestion = normalize(question);
    return entry.keywords.reduce((score, keyword) => {
      const normalizedKeyword = normalize(keyword);
      if (!normalizedKeyword) return score;
      if (normalizedQuestion.includes(normalizedKeyword)) return score + Math.max(2, normalizedKeyword.split(" ").length + 1);
      return score;
    }, 0);
  };

  const longestKeywordMatch = (entry, question) => {
    const normalizedQuestion = normalize(question);
    return entry.keywords.reduce((longest, keyword) => {
      const normalizedKeyword = normalize(keyword);
      if (!normalizedKeyword || !normalizedQuestion.includes(normalizedKeyword)) return longest;
      return Math.max(longest, normalizedKeyword.length);
    }, 0);
  };

  const buildFallbackAnswer = (contactEmail) => ({
    title: "Ik weet het niet zeker",
    answer: "Ik kan hier nog geen betrouwbaar Pinell-antwoord op geven. Controleer de handleiding van je model of neem contact op met support.",
    followup: contactEmail ? `Vermeld bij contact met support het type- en serienummer. E-mail: ${contactEmail}.` : "Vermeld bij contact met support het type- en serienummer."
  });

  const findLocalAnswer = (knowledge, question, contactEmail) => {
    const ranked = knowledge
      .map((entry) => ({
        entry,
        score: scoreEntry(entry, question),
        specificity: longestKeywordMatch(entry, question)
      }))
      .sort((a, b) => b.score - a.score || b.specificity - a.specificity);

    if (!ranked.length || ranked[0].score < 2) {
      return buildFallbackAnswer(contactEmail);
    }

    return ranked[0].entry;
  };

  const renderAssistantMessage = (entry) => {
    const title = entry.title ? `<strong class="pinell-ai-help__message-title">${escapeHtml(entry.title)}</strong>` : "";
    const answer = entry.answer ? `<p>${escapeHtml(entry.answer)}</p>` : "";
    const followup = entry.followup ? `<p>${escapeHtml(entry.followup)}</p>` : "";
    const links = Array.isArray(entry.links) && entry.links.length
      ? `<p>${entry.links.map((link) => `<a href="${escapeHtml(link.url)}">${escapeHtml(link.label)}</a>`).join(" ")}</p>`
      : "";

    return `${title}${answer}${followup}${links}`;
  };

  const appendMessage = (messages, type, html) => {
    const message = document.createElement("div");
    message.className = `pinell-ai-help__message pinell-ai-help__message--${type}`;
    message.innerHTML = html;
    messages.appendChild(message);
    messages.scrollTop = messages.scrollHeight;
    return message;
  };

  const askRemoteAssistant = async (endpoint, question) => {
    const response = await fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ question })
    });

    if (!response.ok) {
      throw new Error("Assistant endpoint failed");
    }

    return response.json();
  };

  const initWidget = (root) => {
    if (root.dataset.pinellReady === "true") return;
    root.dataset.pinellReady = "true";

    const form = root.querySelector("[data-pinell-form]");
    const input = root.querySelector("[data-pinell-input]");
    const messages = root.querySelector("[data-pinell-messages]");
    const knowledgeNode = root.querySelector("[data-pinell-knowledge]");
    const endpoint = root.dataset.endpoint || "";
    const contactEmail = root.dataset.contactEmail || "";
    const knowledge = JSON.parse(knowledgeNode.textContent || "[]");

    appendMessage(messages, "assistant", renderAssistantMessage({
      title: "Pinell helpassistent",
      answer: "Stel je vraag over wifi, internetradio, DAB+, Bluetooth, Spotify Connect, handleidingen of reparatie. Je kunt ook een snelle keuze gebruiken."
    }));

    const submitQuestion = async (question) => {
      const cleanQuestion = question.trim();
      if (!cleanQuestion) return;

      appendMessage(messages, "user", escapeHtml(cleanQuestion));
      input.value = "";
      const button = form.querySelector("button[type='submit']");
      button.disabled = true;
      button.textContent = "Even kijken";

      const pending = appendMessage(messages, "assistant", "<p>Ik zoek het voor je op...</p>");

      try {
        if (endpoint) {
          const remoteAnswer = await askRemoteAssistant(endpoint, cleanQuestion);
          pending.innerHTML = renderAssistantMessage({
            title: remoteAnswer.title || "Antwoord",
            answer: remoteAnswer.answer,
            followup: remoteAnswer.followup,
            links: remoteAnswer.links
          });
        } else {
          const localAnswer = findLocalAnswer(knowledge, cleanQuestion, contactEmail);
          pending.innerHTML = renderAssistantMessage(localAnswer);
        }
      } catch (error) {
        const localAnswer = findLocalAnswer(knowledge, cleanQuestion, contactEmail);
        pending.innerHTML = renderAssistantMessage(localAnswer);
      } finally {
        button.disabled = false;
        button.textContent = "Verstuur";
        messages.scrollTop = messages.scrollHeight;
      }
    };

    form.addEventListener("submit", (event) => {
      event.preventDefault();
      submitQuestion(input.value);
    });

    input.addEventListener("keydown", (event) => {
      if (event.key === "Enter" && !event.shiftKey) {
        event.preventDefault();
        submitQuestion(input.value);
      }
    });

    root.querySelectorAll("[data-pinell-question]").forEach((button) => {
      button.addEventListener("click", () => {
        submitQuestion(button.dataset.pinellQuestion || "");
      });
    });
  };

  document.querySelectorAll("[data-pinell-ai-help]").forEach(initWidget);
})();
